const FontsComponent = () => {
  return (<>
    <link rel="preload" href="/static/fonts/woff2/bold.woff2" as="font" type="font/woff2" crossOrigin="anonymous"/>
    <link rel="preload" href="/static/fonts/woff2/light.woff2" as="font" type="font/woff2" crossOrigin="anonymous"/>
    <link rel="preload" href="/static/fonts/woff2/normal.woff2" as="font" type="font/woff2" crossOrigin="anonymous"/>
  </>)
};

export default FontsComponent;
